import { render, staticRenderFns } from "./visitReturn.vue?vue&type=template&id=4bf5259c&scoped=true&"
import script from "./visitReturn.vue?vue&type=script&lang=js&"
export * from "./visitReturn.vue?vue&type=script&lang=js&"
import style0 from "./visitReturn.vue?vue&type=style&index=0&id=4bf5259c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf5259c",
  null
  
)

export default component.exports